var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconBar = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M5.28381 4.5C4.58691 4.5 4.2379 5.33947 4.73068 5.83043L11.25 12.3256V18H8.25C7.83579 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.83579 19.5 8.25 19.5H15.75C16.1642 19.5 16.5 19.1642 16.5 18.75C16.5 18.3358 16.1642 18 15.75 18H12.75V12.3256L19.2693 5.83043C19.7621 5.33947 19.4131 4.5 18.7162 4.5H5.28381ZM7.17232 6.05869H16.8277L12 10.8685L7.17232 6.05869Z", fill: "#192325" }))),
        alt: 'Bar',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconBar;
//# sourceMappingURL=index.js.map